<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {PRODUCT_NAME} from '@/utils/packages/packages-const'

    @Component
    export class PackagesStoreMixin extends Vue {
        get productStore() {
            return packagesStore
        }

        get productRuntimeStore() {
            return packagesRuntimeStore
        }

        get productType() {
            return 'package'
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default PackagesStoreMixin
</script>
